import clsx from 'clsx'

import type { FC } from 'react'

type Props = {
  className?: string
  children: React.ReactNode
}

export const DetailRoot: FC<Props> = ({ className, children }) => {
  return (
    <div
      data-testid="block-confirmation-data"
      className={clsx('rounded bg-white', className)}
    >
      {children}
    </div>
  )
}
